import React, { useEffect, useRef, useState } from 'react';
import { TreatmentType } from '../models/superbit-api-models';
import ClientAddTaskPopup from './ClientAddTaskPopup';
import AddEmailTreatmentPopup from './AddEmailTreatmentPopup';
import AddDocumentationTreatmentPopup from './_AddDocumentationTreatmentPopup';
import NewEmailMessage from '../emails/_NewEmailMessage';
import { EmailsModel } from '../models/EmailsModel';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../app-context/store';
import EmailContentShow from '../emails/_EmailShowContent';
import { IDNameDescriptionDictionary } from '../models/Site';
import { setCreateTreatmentFrom, setPopUpTreatmentModel, setPopUpTreatmentSuesModel, setTreatmentId } from '../app-context/tasksSlice';
import ChatsMessages from '../whatsup/_ChatsMessages';
import { CustomerCardModel } from '../models/CustomerCardModel';
import { LeadsModel } from '../models/LeadsModel';
import { setPhoneNumberOfLead } from '../app-context/leadsSlice';
import { setSueInsuranceCompanyId } from '../app-context/suesSlice';

type Props = {
    ShowHidePopup?: Function;
    ClosePopup?: Function;
    OnApprove?: Function;
    type: number;
    messageTitle?: string;
    customerId?: string;
    showPopUpMessage?: (message: string) => void;
};

const ClientAddTreatmentPopup = (props: Props) => {
    const emailsModel: EmailsModel = new EmailsModel();
    const customerCardModel: CustomerCardModel = new CustomerCardModel();


    const [popUpType, setPopUpType] = useState<TreatmentType>(TreatmentType._0);
    const [showPrintBtn, setShowPrintBtn] = useState<boolean>(false);
    

    const [showEmailPopUp, setShowEmailPopUp] = useState<boolean>(false);
    const [ShowDocumentationPopUp, setShowDocumentationPopUp] = useState<boolean>(false);
    const [activeMail, setActiveMail] = useState<string>('');

    // new email message
    const [userSignature, setUserSignature] = useState<any>(null);
    const [openTabs, setOpenTabs] = useState<any[]>([]);
    const [sellectedMessageId, setSellectedMessageId] = useState<number>(0);
    const [selectedTab, setSelectedtab] = useState<any | null>(null);
    const [selectedMessage, setSellectedMessage] = useState<any>(null);
    const [popupTitle, setPopupTitle] = useState<string | undefined>(undefined)
    const [popupContent, setPopupContent] = useState<string | null>(null)

    // edit email message
    const [messageIdForMoving, setMessageIdForMoving] = useState<number[]>([])
    const [messageIdForSetting, setMessageIdForSetting] = useState<number[]>([])
    const [isAdmin, setIsAdmin] = useState<boolean>(false)
    const [promptContent, setPromptContent] = useState<string | null>(null)
    const [messageIdForDeletting, setMessageIdForDeletting] = useState<number[]>([])
    const [currentMailAccount, setCurrentMailAccount] = useState<any>({});
    const [userEmails, setUserEmails] = useState<IDNameDescriptionDictionary>({});
    const [ownerName, setOwnerName] = useState<string>('');
    const [messageId, setMessageId] = useState<string>('');
    const [message, setMessage] = useState<any>(null);

    const [phoneNumber, setPhoneNumber] = useState<string>('');
    const [fullName, setFullName] = useState<string>('');

    const typeTreatmentsAction = useSelector((state: RootState) => state.tasks.typeTreatmentsAction);
    const emailMessageId = useSelector((state: RootState) => state.tasks.emailMessageId);

    // for treatment from leads
    const leadIdForTreatment = useSelector((state: RootState) => state.leads.leadIdForTreatment);

    const dispatch = useDispatch();


    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup(status);
        }
        // for treatment from leads and customer card 
        dispatch(setPopUpTreatmentModel({
            show: false,
            type: 0
        }));
        // for sues
        dispatch(setPopUpTreatmentSuesModel({
            show: false,
            type: 0
        }));
        dispatch(setTreatmentId(''));
        dispatch(setCreateTreatmentFrom({ type: '', id: '' }));
        dispatch(setPhoneNumberOfLead(''));
        dispatch(setSueInsuranceCompanyId(''));

    }

    const emptyFunc = () => { }

    useEffect(() => {
        console.log('ClientAddTreatmentPopup', props)
        setPopUpType(props.type);
        switch (props.type) {
            case TreatmentType._0:
                setShowPrintBtn(true)
                break;

            case TreatmentType._3:
                setShowEmailPopUp(true)
                break;
            case TreatmentType._4:
                setShowDocumentationPopUp(true)
                break;

            default:
                break;
        };


        var activeMailNumber = ''
        let activeMailData = localStorage.getItem('activeMail');
        let emailSettings: any = localStorage.getItem('emailSettings');
        if (emailSettings) {
            emailSettings = JSON.parse(emailSettings);
            const mainAccount = emailSettings.emails.find((ea: any) => ea.main == true);
            if (mainAccount) {
                setActiveMail(mainAccount.id);
                activeMailNumber = mainAccount.id;
            } else {
                // setActiveMail(emailSettings.emails[0].id);
            }
        }

        const fetchEmails = async () => {
            if (props.customerId) {
                console.log('getCustomerCardDetails', props.customerId)
                let customer = await customerCardModel.getCustomerCardDetails(props.customerId);
                if (customer) {
                    console.log('customer :>> ', customer);
                    if (customer && customer.personalData && customer.personalData.customerData) {
                        let customerData = customer.personalData.customerData;
                        if (customerData && customerData.customerContactDetails && customerData.customerContactDetails.length > 0) {
                            let phoneNumber = customerData.customerContactDetails[0].number;
                            console.log('phoneNumber', phoneNumber);
                            setPhoneNumber(phoneNumber);
                            setFullName(customerData.fullName);
                        }
                    }
                }

                if (leadIdForTreatment && leadIdForTreatment.length > 0) {
                    const lead = await new LeadsModel().getLeadForUpsert(leadIdForTreatment);
                    if (lead) {
                        console.log('lead', lead);
                        if (lead.phoneNumber1) {
                            setPhoneNumber(lead.phoneNumber1);
                        }

                    }


                }

            }
            let loggedUser: any = localStorage.getItem('loggedUser');
            if (loggedUser) {
                loggedUser = JSON.parse(loggedUser);
                setIsAdmin(loggedUser.role == 0);
                let emailSettings: any = localStorage.getItem('emailSettings');
                localStorage.setItem('emails_' + (new Date()).getTime(), (new Date()).getTime().toString())
                if (!emailSettings) {
                    emailSettings = await emailsModel.getEmailsSettings();
                    localStorage.setItem('emailSettings', JSON.stringify(emailSettings));
                } else {
                    emailSettings = JSON.parse(emailSettings);
                }
                if (emailSettings && emailSettings.emails.length > 0) {
                    configureSettings(emailSettings);
                }
            }
        }


        fetchEmails();


        const getMessageDetails = async () => {
            const request: any = {
                messageId: emailMessageId,
                activeMail: activeMailNumber
            }

            const oMessage = await emailsModel.getMessage(request);
            console.log('oMessage', oMessage)
            if (oMessage) {
                if (oMessage.statusCode) {
                    console.log('oMessage.statusCode', oMessage)
                    setPopupContent(oMessage.statusMessage);
                } else {
                    let date = new Date(oMessage.date);
                    const dateString = date.toLocaleDateString();
                    oMessage.dateString = dateString;
                    // showMessage(oMessage);
                }
            }
            return oMessage;
        }
        if (props.type == TreatmentType._3) {

            if (typeTreatmentsAction == "edit") {

                getMessageDetails().then((oMessage: any) => {
                    console.log('oMessage', oMessage)
                    if (oMessage) {
                        setSellectedMessage(oMessage);
                        setSellectedMessageId(oMessage.messageId);
                        setSelectedtab(oMessage.id);



                        setSellectedMessageId(0);
                        setSelectedtab(null);
                        setSellectedMessage(null);
                        const messageId: number = (new Date()).getTime();
                        const message = {
                            from: oMessage.envelope.from,
                            envelope: { ...oMessage.envelope },
                            body: oMessage.htmlBody,
                            htmlBody: oMessage.htmlBody,
                            date: oMessage.date,
                            to: oMessage.envelope.to,
                            cc: oMessage.envelope.cc,
                            title: '',
                            bcc: oMessage.envelope.bcc,
                            id: emailMessageId,
                            attachments: oMessage.attachments,
                            subject: oMessage.subject,
                        }
                        const tabContent = {
                            type: 'newMessage',
                            id: emailMessageId,
                            title: 'הודעה חדשה',
                            message,
                        }
                        openTabs.push(tabContent);
                        setOpenTabs(openTabs);
                        setSellectedMessageId(messageId);
                        setSellectedMessage(tabContent);
                    }
                })

            } else {

                setSellectedMessageId(0);
                setSelectedtab(null);
                setSellectedMessage(null);
                const messageId: number = (new Date()).getTime();
                const message = {
                    body: '',
                    to: '',
                    cc: '',
                    title: '',
                    bcc: '',
                    id: messageId,
                    attachments: []
                }
                const tabContent = {
                    type: 'replyMessage',
                    id: messageId,
                    title: 'הודעה חדשה',
                    message,
                }
                openTabs.push(tabContent);
                setOpenTabs(openTabs);
                setSellectedMessageId(messageId);
                setSellectedMessage(tabContent);
            }
        }

    }, [])

    const sendMail = async (formData: any, tabId?: number) => {
        // setLoading(true);
        const res = await emailsModel.emailsSendMessage(formData);
        console.log('res', res)
        if (res.label == "OK") {
            setMessageId(res.code);
        }

        if (res && res.statusCode == 200) {
            setPopupTitle('שליחת מייל')
            setPopupContent('הודעה נשלחה בהצלחה');
            return res;
        } else {
            setPopupTitle('שליחת מייל')
            setPopupContent('שליחת הודעה נכשלה');
        }
        if (tabId) {
            console.log('selectedTab', tabId);
            // closeMessage(tabId)
        }
        // setLoading(false);
        // showEmails();
        return res;
    }

    const openPopup = (data: any) => {
        setPopupTitle(data.title)
        setPopupContent(data.description);
    }

    const updateTabData = (tabId: string, tabData: any) => {
        console.log('tabData', tabData);
        let tabIndex = openTabs.findIndex((m: any) => m.id == tabId);
        const message = {
            body: tabData.body,
            to: tabData.to,
            cc: tabData.cc,
            title: tabData.title,
            bcc: tabData.bcc,
            attachments: tabData.attachments
        };
        openTabs[tabIndex] = {
            type: 'newMessage',
            id: tabId,
            title: 'הודעה חדשה: ' + tabData.title,
            message,
        }
        setOpenTabs(openTabs);
        console.log(openTabs);
    }

    const onMoveMessageClick = (messageUid: number) => {
        setMessageIdForMoving([messageUid])
    }

    const onSetMessageClick = (messageUid: number) => {
        setMessageIdForSetting([messageUid])
    }

    const openPromptPopUp = (mid: number) => {
        setPromptContent('האם את/אתה בטוח/ה?');
        setMessageIdForDeletting([mid]);
    }

    const configureSettings = (emailSettings: any) => {
        if (emailSettings) {
            if (emailSettings.emails && emailSettings.emails.length > 0) {
                const emailAccounts: IDNameDescriptionDictionary = emailSettings.emails.map((a: any) => {
                    return {
                        description: a.emailAddress,
                        name: a.name,
                        email: a.emailAddress,
                        id: a.id,
                        signature: a.electronicSignature
                    }
                }) as IDNameDescriptionDictionary;
                const mainAccount = emailSettings.emails.find((ea: any) => ea.main == true);
                setUserEmails(emailAccounts);
                let signature: string = '';
                if (mainAccount) {
                    setActiveMail(mainAccount.id);
                    setOwnerName(mainAccount.name);
                    setCurrentMailAccount(mainAccount);
                    // setUserSignature(mainAccount.electronicSignature);
                    signature = mainAccount.electronicSignature
                } else {
                    setActiveMail(emailSettings.emails[0].id);
                    setOwnerName(emailSettings.emails[0].name);
                    setCurrentMailAccount(emailSettings.emails[0]);
                    signature = emailSettings.emails[0].electronicSignature;
                }
                setUserSignature(signature);
                localStorage.setItem('userSignature', signature);
            }
        }
    }


    return (<>

        {popUpType == 1 ? (
            // showAddTreatmentPopUp && selectedAssigment && customersList.length > 0 &&

            <ClientAddTaskPopup
                customerId={props.customerId}
                showPopUpMessage={props.showPopUpMessage || (() => { })}
                ClosePopup={closePopup}
            />

        ) :
            popUpType == TreatmentType._3 ? (
                <div className={`popup-wrapper add-treatment-popup ${props.type}`}>
                    <section className="popup-window rtl">
                        <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>
                        <div className="popup-content">
                            {typeTreatmentsAction == "new" ?
                                <>
                                    <div className="popup-header">
                                        <div className="popup-title">
                                            {'מייל חדש'}
                                        </div>
                                    </div>
                                    <div className="popup-body">

                                        <NewEmailMessage
                                            activeMail={activeMail}
                                            signature={userSignature}
                                            sendMail={sendMail}
                                            openPopup={openPopup}
                                            subject={selectedMessage.message.title}
                                            body={selectedMessage.message.body}
                                            attachments={selectedMessage.message.attachments}
                                            cc={selectedMessage.message.cc}
                                            to={selectedMessage.message.to}
                                            bcc={selectedMessage.message.bcc}
                                            tabId={selectedMessage.id}
                                            updateTabData={updateTabData}
                                            customerId={props.customerId}
                                            showPopUpMessage={props.showPopUpMessage || (() => { })}
                                            ClosePopup={closePopup}
                                        />
                                    </div>
                                </>
                                :
                                <>
                                    <div className="popup-header">
                                        <div className="popup-title">
                                            {'מייל קיים'}
                                        </div>
                                    </div>
                                    <div className="popup-body">

                                        <EmailContentShow
                                            activeMail={activeMail}
                                            // messageId={sellectedMessageId}
                                            messageId={emailMessageId ? emailMessageId : selectedMessage.message.id}

                                            message={selectedMessage && selectedMessage.message ? selectedMessage.message : {}}
                                            sendMail={sendMail}
                                            onStarClick={() => { }}
                                            onMoveMessageClick={onMoveMessageClick}
                                            onSetMessageClick={onSetMessageClick}
                                            isAdmin={isAdmin}
                                            onDeleteMessage={isAdmin ? openPromptPopUp : () => { }}
                                            openPopup={openPopup}
                                            mainAccount={currentMailAccount}
                                            folderName={selectedMessage && selectedMessage.folderName ? selectedMessage.folderName : ''}
                                            folderType={selectedMessage && selectedMessage.folderType ? selectedMessage.folderType : ''}
                                            fromTreatment={true}
                                            ClosePopup={closePopup}
                                            showPopUpMessage={props.showPopUpMessage || (() => { })}
                                        />
                                    </div>
                                </>
                            }
                        </div>
                    </section>
                </div>
            )
                // <AddEmailTreatmentPopup type={3} customerId={props.customerId} ClosePopup={closePopup} activeMail={activeMail} showPopUpMessage={props.showPopUpMessage || (() => { })} />
                :
                popUpType == 4 ?
                    <AddDocumentationTreatmentPopup type={4} customerId={props.customerId} ClosePopup={closePopup} showPopUpMessage={props.showPopUpMessage || (() => { })} />
                    :
                    popUpType == 2 ?
                        <ChatsMessages phoneNumber={phoneNumber} fullName={fullName} ClosePopup={closePopup} customerId={props.customerId} /> :
                        <></>
        }
    </>

    );
    // }
}
export default ClientAddTreatmentPopup;